<template>
  <v-container fluid>
    <v-row align="stretch">
      <v-col cols="12">
        <v-text-field v-model="searchTerm" label="Search..."/>
      </v-col>
    </v-row>
    <v-row align="stretch">
      <v-col v-for="(poster) in filteredPosters" :key="poster.id" cols="12" sm="6" md="4">
        <poster :poster="poster"></poster>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Poster from '@/components/Poster';
import {mapMutations, mapState} from 'vuex';


export default {
  name: 'Posters',
  data() {
    return {
      searchTerm: ''
    }
  },
  components: {
    Poster,
  },
  mounted() {
    this.setPosterLoading(false)
  },
  computed: {
    ...mapState(['event']),
    filteredPosters() {
      if(!this.event) {
        return []
      }
      if(!this.searchTerm) {
        return this.event.posters
      }
      let prioritizedPosters = this._.map(this.event.posters,(poster)=>{
        let posterCopy = Object.assign({}, poster)
        let terms = this.searchTerm.split(' ')
        let contains = 0
        terms.forEach((term)=>{
          if(poster.title.toLowerCase().includes(term.toLowerCase()) || poster.author.toLowerCase().includes(term.toLowerCase())) {
            contains++
          }
        })
        posterCopy.searchPriority = contains
        return posterCopy
      })
      let filteredPosters = this._.filter(prioritizedPosters, (poster) => {return poster.searchPriority>0})
      return this._.orderBy(filteredPosters, 'searchPriority', 'desc')
    }
  },
  methods: {
    ...mapMutations(['setPosterLoading']),
  },
};
</script>

<style scoped>

</style>